import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tagItem: {
    backgroundColor: '#EEEEEE',
    borderRadius: 10,
    marginBottom: 13,
    marginRight: 16,
    padding: '5px 14px',
    '& a': {
      color: '#4D4F5C',
      '&:hover': {
        fontWeight: 400,
      },
    },
  },

  textSecondary: {
    color: '#4D4F5C',
  },
}));

export default useStyles;
